import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason;
  const isTimeout =
    reason?.code === 'ECONNABORTED' ||
    String(reason?.message || '').toLowerCase().includes('timeout');

  if (isTimeout) {
    // امنع شاشة Runtime Error الحمراء عند انقطاع مؤقت في الشبكة/الخادم
    event.preventDefault();
    console.warn('Network timeout handled gracefully:', reason?.message || reason);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
